import { useCallback, useEffect } from "react";
/**
 * update the browsers query params silently without
 * updating the history
 */
const useUpdateQueryParams = (
  params: Record<string, any>,
  removeIfEmpty: boolean = true
) => {
  const updateQueryParams = useCallback(
    (queryParams: Record<string, any>, removeIfEmpty: boolean) => {
      const url = new URL(window.location.href);
      const fields = Object.keys(queryParams);

      fields.forEach(field => {
        const value = queryParams[field];
        if (value) {
          url.searchParams.set(field, value);
        } else if (removeIfEmpty) {
          url.searchParams.delete(field);
        }
      });

      window.history.replaceState({}, "", url);
    },
    []
  );

  useEffect(() => {
    updateQueryParams(params, removeIfEmpty);
  }, [params, removeIfEmpty, updateQueryParams]);

  const update = useCallback(
    (params: Record<string, any>, removeIfEmpty: boolean = true) =>
      updateQueryParams(params, removeIfEmpty),
    [updateQueryParams]
  );

  return { update };
};

export default useUpdateQueryParams;
